import { ReactNode } from 'react';
import { ReactComponent as GlueMetaStoreIcon } from '@elementary/common-ui/assets/16x16/glue-metastore.svg';
import { ReactComponent as BigQueryIcon } from '@elementary/common-ui/assets/data-warehouses/bigquery.svg';
import { DataCatalogMetaStore } from 'shared/types';

export const getMetastoreIcon = (
  catalogType: DataCatalogMetaStore,
  size = 16,
): ReactNode => {
  const icons: Record<DataCatalogMetaStore, ReactNode> = {
    GLUE: <GlueMetaStoreIcon width={size} height={size} />,
    BIGLAKE: <BigQueryIcon width={size} height={size} />,
  };
  return icons[catalogType];
};

export const METASTORE_ICON_MAP: Record<DataCatalogMetaStore, ReactNode> = {
  GLUE: getMetastoreIcon('GLUE'),
  BIGLAKE: getMetastoreIcon('BIGLAKE'),
};
